import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import HomePage from '@/pages/HomePage';
import MenuPage from '@/pages/MenuPage';
import BookingPage from '@/pages/BookingPage';
import AdminDashboard from '@/pages/AdminDashboard';
import FloatingActions from '@/components/FloatingActions';
import '@/App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/menu" element={<MenuPage />} />
          <Route path="/book-seat" element={<BookingPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
        <FloatingActions />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;